import { useEffect, useState, useMemo } from 'react';
// eslint-disable-next-line jira/wrm/no-load-bridge
import {
	waitForHeritage,
	loadBridgeStrict,
	loadBridgeWeak,
} from '@atlassian/jira-common-bridge/src';
import { fg } from '@atlassian/jira-feature-gating';
import { BANNER_NAME, bannerHeight } from '../common/constants.tsx';

export const useBannerIPBlocklisting = () => {
	const [shouldShowBanner, setBannerState] = useState(false);

	useEffect(() => {
		if (fg('firefox_issue_view_memory_leak_v1')) {
			// eslint-disable-next-line jira/wrm/no-load-bridge
			waitForHeritage()?.then(() =>
				// eslint-disable-next-line jira/wrm/no-load-bridge
				loadBridgeStrict({
					wrmKeys: ['wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting'],
					name: 'jira/global-components/ipblocklisting/bridge',
				}).then((bridge) => {
					// @ts-expect-error - TS2571 - Object is of type 'unknown'.
					bridge({
						showIPBlocklistBanner: () => setBannerState(true),
						hideIPBlocklistBanner: () => setBannerState(false),
					});
				}),
			);
		} else {
			// eslint-disable-next-line jira/wrm/no-load-bridge
			loadBridgeWeak({ name: 'jira/global-components/ipblocklisting/bridge' }).then((bridge) => {
				// @ts-expect-error - TS2571 - Object is of type 'unknown'.
				bridge({
					showIPBlocklistBanner: () => setBannerState(true),
					hideIPBlocklistBanner: () => setBannerState(false),
				});
			});
		}
	}, []);

	return useMemo(
		() => ({
			isEnabled: shouldShowBanner,
			name: BANNER_NAME,
			height: bannerHeight,
		}),
		[shouldShowBanner],
	);
};
